import { useQuery } from 'react-query';

import { GetSummaryRes } from '../types/queries';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSummary = ({
  matterId,
  subsetId,
}: {
  matterId: string | undefined;
  subsetId: string | undefined;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getSummary = async (): Promise<GetSummaryRes> => {
    const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/summary`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching messages failed');
    }

    if (response.headers.get('content-type')?.includes('application/json')) {
      return response.json();
    }
  };

  return useQuery([QueryEntity.Summary, { matterId, subsetId }], getSummary, {
    enabled: !!matterId && !!subsetId,
  });
};
